const InputMask = () => {
  $('[rel="cep"]').mask('00000-000', {
    placeholder: '_____-___'
  });
};

export default InputMask;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/books/inputMask.js